export type McNextSubmissionUrlProps = {
  mcNextFormHandlerSubmitUrl?: string;
};

export type MarketingSubmissionFields = Record<string, string>;

type SalesforceInteractionsApi = {
  currentConsentOptInExists: () => boolean;
  getAnonymousId: () => string;
};

type SubmitMarketingFormParams = {
  mcNextFormHandlerSubmitUrl?: McNextSubmissionUrlProps['mcNextFormHandlerSubmitUrl'];
  pardotSubmissionUrl?: string;
  fields: MarketingSubmissionFields;
};

type SubmitToPardotParams = {
  pardotSubmissionUrl: string;
  fields: MarketingSubmissionFields;
};

type SubmitToMcNextParams = {
  mcNextFormHandlerSubmitUrl: string;
  fields: MarketingSubmissionFields;
};

export const isMcNextSubmissionQualified = (mcNextFormHandlerSubmitUrl?: string) => {
  return Boolean(mcNextFormHandlerSubmitUrl?.trim());
};

const getSalesforceAnonymousId = () => {
  const salesforceInteractions = (
    window as Window & {
      SalesforceInteractions?: SalesforceInteractionsApi;
    }
  ).SalesforceInteractions;

  if (
    !salesforceInteractions?.currentConsentOptInExists ||
    !salesforceInteractions?.getAnonymousId
  ) {
    return '';
  }

  return salesforceInteractions.currentConsentOptInExists()
    ? salesforceInteractions.getAnonymousId()
    : '';
};

const submitToPardot = ({ pardotSubmissionUrl, fields }: SubmitToPardotParams) => {
  return fetch(pardotSubmissionUrl, {
    method: 'POST',
    mode: 'no-cors',
    redirect: 'follow',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams(fields).toString()
  });
};

const submitToMcNext = ({ mcNextFormHandlerSubmitUrl, fields }: SubmitToMcNextParams) => {
  return fetch(mcNextFormHandlerSubmitUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      formData: fields,
      uniqueId: getSalesforceAnonymousId()
    })
  }).then(response => {
    if (!response.ok) {
      throw new Error(`MCNext form handler submit failed with status ${response.status}`);
    }
  });
};

export const submitMarketingForm = ({
  mcNextFormHandlerSubmitUrl,
  pardotSubmissionUrl,
  fields
}: SubmitMarketingFormParams) => {
  const qualifiedMcNextFormHandlerSubmitUrl = mcNextFormHandlerSubmitUrl?.trim();

  if (qualifiedMcNextFormHandlerSubmitUrl) {
    return submitToMcNext({
      mcNextFormHandlerSubmitUrl: qualifiedMcNextFormHandlerSubmitUrl,
      fields
    });
  }

  if (pardotSubmissionUrl?.trim()) {
    return submitToPardot({
      pardotSubmissionUrl: pardotSubmissionUrl.trim(),
      fields
    });
  }

  throw new Error('No form handler is configured.');
};
